export interface OpenPopoverEntry {
  id: symbol;
  contains: (target: Node) => boolean;
  element: () => HTMLElement | undefined;
}

const openPopovers: OpenPopoverEntry[] = [];
const handledEscapeEvents = new WeakSet<Event>();

export const markPopoverOpen = (entry: OpenPopoverEntry): void => {
  removeOpenPopover(entry);
  openPopovers.push(entry);
};

export const removeOpenPopover = (entry: OpenPopoverEntry): void => {
  const index = openPopovers.findIndex(openPopover => openPopover.id === entry.id);
  if (index !== -1) openPopovers.splice(index, 1);
};

export const hasOpenPopoverWithin = (container: Node): boolean =>
  openPopovers.some(openPopover => {
    const element = openPopover.element();
    return Boolean(element && container.contains(element));
  });

export const shouldHandlePopoverEscape = (entry: OpenPopoverEntry, event: Event, targets: (Node | null)[]): boolean => {
  if (handledEscapeEvents.has(event)) return false;

  const openPopoversByRecency = [...openPopovers].reverse();

  for (const target of targets) {
    if (!target) continue;

    const owner = openPopoversByRecency.find(openPopover => openPopover.contains(target));
    if (owner) {
      if (owner.id !== entry.id) return false;

      handledEscapeEvents.add(event);
      return true;
    }
  }

  if (openPopoversByRecency[0]?.id !== entry.id) return false;

  handledEscapeEvents.add(event);
  return true;
};
